import React, { useEffect, useState } from 'react';

import { track } from '@betterment/js-runtime';
import { Box, Icon, Text } from '@betterment/samba-react';
import { Button, CenteredWorkflowLayout, Heading } from '@betterment/style-closet-react';

import Footer from '../Shared/components/Footer';

interface Props {
  onClose: () => void;
}

const AccountLimitReached: React.FC<React.PropsWithChildren<Props>> = ({ onClose }) => {
  useEffect(() => {
    track('ElementViewed', { name: 'MaxCheckingAccounts', flow: 'OpenJointCheckingSecondary' });
  }, []);

  const [isButtonDisabled, setButtonDisabled] = useState(false);

  const onAck = () => {
    setButtonDisabled(true);
    track('ElementClicked', { name: 'GotIt', flow: 'OpenJointCheckingSecondary' });
    onClose();
  };

  return (
    <CenteredWorkflowLayout title="Joint Checking signup" closeHandler={onClose}>
      <CenteredWorkflowLayout.Slot name="content">
        <Box
          css={{
            marginBottom: 'space.300',
          }}
        >
          <Icon name="ExclamationCircle" size="large" color="icon" />
        </Box>
        <Heading as="h1" variant="primary">
          You've reached your Checking account limit
        </Heading>
        <Box
          css={{
            marginBottom: 'space.400',
          }}
        >
          <Text as="p">
            You can only have two Checking accounts at a time. Please close one of your existing accounts to continue.
          </Text>
        </Box>
        <CenteredWorkflowLayout.Actions>
          <Button type="button" px="8" onClick={onAck} disabled={isButtonDisabled}>
            Got it
          </Button>
        </CenteredWorkflowLayout.Actions>
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="footer">
        <Footer />
      </CenteredWorkflowLayout.Slot>
    </CenteredWorkflowLayout>
  );
};

export default AccountLimitReached;
